import classNames from "classnames";
import { IFImg } from "@libs/utils/IFImg";
import styles from "./index.module.css";
import type { FC, MouseEventHandler } from "react";

type Props = {
  label: string;
  inactiveIconPath: string;
  activeIconPath?: string;
  isActive?: boolean;
  layout?: "small" | "spSmallBox";
  onClick: MouseEventHandler<HTMLButtonElement>;
};

const TogglableIconButton: FC<Props> = ({
  inactiveIconPath,
  activeIconPath,
  label,
  onClick,
  isActive = false,
  layout,
}) => {
  return (
    <button
      className={classNames(styles.button, {
        [styles.small]: layout === "small",
        [styles.spSmallBox]: layout === "spSmallBox",
      })}
      onClick={onClick}
    >
      <span
        className={classNames(
          styles.wrapper,
          styles.buttonLabel,
          isActive && styles.isActive
        )}
      >
        <i>
          {/*切り替えるたびに画像リクエストするのを避けるため、cssのdisplayでの切り替えをしている*/}
          <img
            className={classNames(isActive && styles.showIcon)}
            src={IFImg(activeIconPath)}
            alt={label}
          />
          <img
            className={classNames(!isActive && styles.showIcon)}
            src={IFImg(inactiveIconPath)}
            alt={label}
          />
        </i>
        <span className={styles.labelText}>{label}</span>
      </span>
    </button>
  );
};

export default TogglableIconButton;
